export default __webpack_public_path__ + "static/media/32_photo.460e7e32.jpeg";